module.exports = __webpack_public_path__ + "static/entrance-47a1405cf777c2666b16dd2d1c0a85de.jpg";